import axios from '../../../axios'

export default {
  getSmartReferenceSettingsForRailObject: function (railobjectId) {
    return axios
      .get('switch/smartReference/' + railobjectId)
  },
  getSmartReferenceAlgorithms: function () {
    return axios
      .get('switch/smartReference/algorithms')
  },
  getSmartReferenceTemperatureBinGroups: function () {
    return axios
      .get('switch/smartReference/temperatureBinGroups')
  },
  getSmartReferenceSectionTypes: function () {
    return axios
      .get('switch/smartReference/sectionTypes')
  },
  getMotors: function (railobjectId) {
    return axios
      .get('switch/smartReference/motors/' + railobjectId)
  },
  async saveSmartReferenceSettings (settings, railObjectId) {
    var result = await axios.put('switch/smartReference/' + railObjectId, settings)
    return result.data
  }
}



// WEBPACK FOOTER //
// ./src/services/api/switch/SmartReferenceApi.js